import * as React from 'React';


type Props = {
    title: string;    
    message: string;
}

const Message = ({title =  '', message = 'form stored' }: Props) =>{
    return (<>
            <div>{title}</div>
            <div>{message}</div>
            </>)
}

export default Message;
